export const SET_PATIENT_DATA = 'SET_PATIENT_DATA';
export const LOAD_PATIENT_ADDRESS_SUCCESS = 'LOAD_PATIENT_ADDRESS_SUCCESS';
